<template>
<basepage :title="$t('Invoice-Status-Query')" :status="status">
  <div class="input-group">
    <div>
      <v-radio-group v-model="radioGroup" row>
        <v-radio label="E Fatura" :value="1"></v-radio>
        <v-radio label="E Arşiv" :value="2"></v-radio>
        <v-text-field hide-details :label="$t('Date') +  '1'" type="date" v-model="tarih1"></v-text-field>
        <v-text-field hide-details :label="$t('Date') +  '1'" type="date" v-model="tarih2"></v-text-field>
        <v-btn :disabled="status.loading" @click="Sorgula()"> {{ $t('Inquire-Invoice-Status') }} </v-btn>
      </v-radio-group>
    </div>
  </div>
  <pre><code>{{desserts}}</code></pre>

</basepage>

</template>

<script>
import basepage from "@/components/app/coper/comp/basepage.vue";
import tool from "../coper/tools";

export default {
  components: {
    basepage,
  },
  data() {
    return {
      status: tool.NewSatatus(),
      tarih1: tool.Now_yyyy_MM_dd(),
      tarih2: tool.Now_yyyy_MM_dd(),
      radioGroup: 1,
      desserts: []
    };
  },
  methods: {
    Sorgula() {
      var prm = {
        tip: this.radioGroup,
        tarih1: this.tarih1,
        tarih2: this.tarih2
      };
      this.status.loading = true;
      this.desserts = [];

      tool.api_post(this, "EFatura/EFaturaDurumSorgula", prm).then(
        response => {
          this.desserts = response.body;
          this.status.loading = false;
        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );

    }
  },
};
</script>
